import { render, staticRenderFns } from "./departmentBanner.vue?vue&type=template&id=3f73d666&scoped=true"
import script from "./departmentBanner.vue?vue&type=script&lang=js"
export * from "./departmentBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f73d666",
  null
  
)

export default component.exports